<template>
    <div class="animated fadeIn">
        <b-row class="my-3">
            <b-col>
                <h4 class="text-center text-primary">
                    <i class="fa fa-users text-primary mr-2"></i>
                    Gestión de Categorías de Consulta
                </h4>
            </b-col>
        </b-row>

        <b-row class="pb-2">
            <b-card class="w-100">
                <b-row slot="header" class="m-0 p-0 justify-content-between align-items-center">
                    Listado
                    <export-actions :rows="getQueryCategoriesFilteredData()"></export-actions>
                </b-row>
                <v-client-table
                    ref="QueryCategoriesTable"
                    class="dataTable"
                    md="12"
                    lg="12"
                    sm="12"
                    :columns="columns"
                    :data="queryCategories"
                    :options="options"
                    :theme="theme">

                    <template slot="name" slot-scope="props">
                        <template
                            v-if="!!props.row.depth && props.row.depth>0"
                            v-for="n in props.row.depth">-
                        </template>
                        {{ props.row.name }}
                    </template>

                    <template slot="uuid" slot-scope="props">
                        <router-link :to="{ path: '/queries/categories/edit/'+props.row.uuid }">
                            <i class="fa fa-pencil"></i>
                        </router-link>
                    </template>

                    <template slot="parent" slot-scope="props">
                        <template v-if="props.row.parent">
                            {{ props.row.parent.name }}
                        </template>
                    </template>

                </v-client-table>

            </b-card>
        </b-row>

    </div>
</template>

<script>

    import Vue from 'vue';
    import form from '@/helpers/form';
    import {ClientTable, Event} from 'vue-tables-2';
    import ExportActions from '@/components/ExportActions';
    import {getQueryCategoriesTree} from '@/api/query-category-api';

    Vue.use(ClientTable);

    export default {
        name: 'list-query-categories',
        components: {
            ExportActions
        },
        data: function () {
            return {
                topmenu: [
                    {
                        name: 'Inicio',
                        path: '/admin/dashboard',
                        brand: 'fa fa-home'
                    },
                    {
                        name: 'Nueva Categoría',
                        path: '/queries/categories/add',
                        brand: 'fa fa-user',
                        permissions: ['QUERY_CATEGORY_NEW']
                    },
                ],
                columns: ['uuid', 'name'],
                options: {
                    headings: {
                        uuid: {
                            text: '',
                            id: 'fit'
                        },
                        name: 'Nombre',
                    },
                    columnsClasses: {
                        uuid: "fit"
                    },
                    sortable: ['name'],
                    filterable: ['name'],
                    sortIcon: {
                        base: 'fa',
                        up: 'fa-sort-asc',
                        down: 'fa-sort-desc',
                        is: 'fa-sort'
                    },
                    texts: null,
                    pagination: {
                        chunk: 5,
                        edge: true,
                        nav: 'scroll'
                    }
                },
                useVuex: false,
                theme: 'bootstrap4',
                template: 'default',
                queryCategories: [],
            }
        },
        mounted() {
            this.options.texts = form.tableLabels();
            this.$eventHub.$emit('captureMenu', this.topmenu);
            this.getQueryCategories();
        },
        methods: {
            async getQueryCategories() {
                this.$_loadingMixin_showLoading();
                await getQueryCategoriesTree()
                    .then((queryCategories) => {
                        this.queryCategories = queryCategories;
                    });
                this.$_loadingMixin_hideLoading();
            },
            getQueryCategoriesFilteredData() {
                if (!!this.$refs.QueryCategoriesTable) {
                    return this.$refs.QueryCategoriesTable.allFilteredData.map(queryCategory => ({
                        'Nombre': this.getDepthName(queryCategory),
                    }));
                } else {
                    return [];
                }
            },
            getDepthName(queryCategory) {
                let depth = "";
                for (let i = 0; i < queryCategory.depth; i++) {
                    depth += "-"
                }
                return depth + " " + queryCategory.name;
            }
        }
    }
</script>